module.exports = __webpack_public_path__ + "static/importantInfoAndActionsYes-d31cd2ed1d15bdb95e2107404d92aa42.png";